import { render } from "./CheckboxSpetial.vue?vue&type=template&id=0570a4d5&scoped=true"
import script from "./CheckboxSpetial.vue?vue&type=script&lang=js"
export * from "./CheckboxSpetial.vue?vue&type=script&lang=js"

import "./CheckboxSpetial.vue?vue&type=style&index=0&id=0570a4d5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0570a4d5"

export default script